export default __webpack_public_path__ + "static/media/cadillac.1e4c1992.png";